export enum ChatMode {
  RAIL = 'rail',
  FLOATING = 'floating',
}

export interface FloatingPosition {
  x: number
  y: number
}

export interface FloatingSize {
  height: number
  width: number
}
